/* eslint-disable */
import React from 'react';

import { connect } from "react-redux";
import {
    Input,
    Button,
    Navbar,
    Nav,
    NavLink,
    Col,
    Row,
    Spinner,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Label,
    UncontrolledTooltip,
} from 'reactstrap'
import NavBar from '../NavBar/navBar'
import radioButton from '../../assets/radioButton.svg'
import { faCalendar, faUpload } from '@fortawesome/free-solid-svg-icons';
import uploadIcon from '../../assets/upload.svg'
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { NavLink as RRNavLink } from 'react-router-dom';
import zoomInIcon from '../../assets/zoom-in.svg'
import zoomOutIcon from '../../assets/zoom-out.svg'
import unknownLocation from '../../assets/unknown_location.png';
import ImageMapper from '../ImageMapper/imageMapper'
import ResultDisplaySamples from '../ResultDisplaySamples/resultDisplaySamples'
import FloorResultDisplay from '../FloorResultDisplay/floorResultDisplay'
import Tour from '../../Tour';
import eyeIcon from '../../assets/eye-highlight.svg'
import listIcon from '../../assets/list-blue.svg'
import deleteIconRed from '../../assets/delete-red-outline.svg'
import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg'
import {
    fetchBuilding,
    fetchFloors,
    fetchFloorPlan,
    fetchLocationResultsData,
    saveSample,
    updateSample,
    uploadResults,
    downloadResultData,
    deleteSample,
    fetchFilterOptions,
    downloadSampleData
} from '../../actions'
import './microbiomeResults.css';
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../AppInsights';
import { SeverityLevel } from '@microsoft/applicationinsights-common';
let building = sessionStorage.getItem("building")
let buildingId = sessionStorage.getItem("buildingId")
let buildingName = sessionStorage.getItem("buildingName")
let floor = sessionStorage.getItem("floor")
let floorId = sessionStorage.getItem("floorId")
let floorName = sessionStorage.getItem("floorName")
// const ExcelFile = ExcelFile;
// const ExcelSheet = ExcelFile.ExcelSheet;
// const ExcelColumn = ExcelFile.ExcelColumn;
const dataset = []

const initialState = {
    name: "floor-map",
    width: 0,
    height: 0,
    analysis: "SNP",
    checkedState: true,
    show: false,
    filterComplexList: [],
    resultBuilding: building ? building : "",
    resultFloor: floor ? floor : "",
    resultOrganism: localStorage.getItem("guest") ? "Salmonella" : "",
    resultBatchNo: "",
    resultSampleType: "",
    zoomInEnabled: true,
    zoomOutEnabled: true
}

let edit = false
let isDisable = false
let errorDetails = ""
let editSampleId = ""

class microbiomeResults extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchFilterOptions()
        this.props.fetchBuilding()
        this.onSelectBuilding = this.onSelectBuilding.bind(this)
        this.onSelectFloor = this.onSelectFloor.bind(this)
        this.onDateChange = this.onDateChange.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

        building = sessionStorage.getItem("building")
        floor = sessionStorage.getItem("floor")
        this.floorInitialState = {
            resultBuilding: building ? building : localStorage.getItem("guest") ? "BldgA" : "",
            resultFloor: floor ? floor : localStorage.getItem("guest") ? 20000 : "",
            floorId: floorId ? floorId : localStorage.getItem("guest") ? 20000 : "",
            buildingId: buildingId ? buildingId : localStorage.getItem("guest") ? 20000 : "",
            datetime: localStorage.getItem("guest") ? new Date(moment().subtract(1, "days")) : "",
            todatetime: localStorage.getItem("guest") ? new Date(moment().subtract(1, "days")) : "",
            show: localStorage.getItem("guest") ? true : false,
            resultOrganism: "",
            resultSampleType: "",
            clickedFloorArea: undefined,
            floorSampleResults: undefined,
            building: building ? building : localStorage.getItem("guest") ? "BldgA" : "",
            floor: floor ? floor : localStorage.getItem("guest") ? 20000 : "",
            buildingName: buildingName ? buildingName : localStorage.getItem("guest") ? "Building A" : "",
            floorName: floorName ? floorName : localStorage.getItem("guest") ? "Floor A" : "",
            loader: false,
            isUploadModalOpen: false,
            fileName: "Results_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
        }
        this.state = Object.assign(initialState, this.floorInitialState);

        setTimeout(() => {
            if (localStorage.getItem("guest"))
                this.applyFilter()
        });
    }


    componentWillMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    
    componentDidMount() {
        if (sessionStorage.getItem("building"))
            this.onSelectBuilding("", true)
        
        // Below function calls are for the automatic setting of values on load
        this.props.fetchBuilding().then( () =>{
            this.onSelectBuilding("", 'onMount')
            this.onSelectFloor("","onMount")
            this.onToDateChange()
            this.props.downloadSampleData().then(() => {
                this.onDateChange()
                if(this.state.floor){
                    this.applyFilter()
                }
            })
        })  
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        let width = window.innerWidth > 1114 ? window.innerWidth * 0.75 : window.innerWidth * 0.66
        this.setState({ width: 865, height: 550, zoomOutEnabled: false, zoomInEnabled: width < 2000 ? true : false });
    }

    getEarliestDate() {
        let data = this.props.sampleData
        let dates = []
        let max_date
        if(data.length>0){
          for(let value of data){
              dates.push(value['date_time'].split('T')[0])
            }
            max_date = dates.reduce(function (a, b) { return a < b ? a : b; });      
       }
        else{
            max_date = moment.utc(new Date(new Date().setFullYear(new Date().getFullYear() - 2)))['_d']
        }
      return (max_date)
    }

    onSelectBuilding = (event, flag = false) => {
        if (flag === false) {
            const { value, selectedOptions } = event.target
            sessionStorage.setItem("building", value)
            sessionStorage.setItem("buildingId", selectedOptions[0].id)
            sessionStorage.setItem("buildingName", selectedOptions[0].innerText)
            sessionStorage.setItem("floor", "")
            sessionStorage.setItem("floorId", "")
            sessionStorage.setItem("floorName", "")
        }
        else if(flag=="onMount" 
        && this.props.buildingList 
        && this.props.buildingList.length>0
        ){
            sessionStorage.setItem("building",this.props.buildingList[0]['building_id'])
            sessionStorage.setItem("buildingId",this.props.buildingList[0]['id'])
            sessionStorage.setItem("buildingName",this.props.buildingList[0]['building_name']) 
            if(this.props.buildingList[0]['floors'].length==0){
                sessionStorage.setItem("floorName","")
                sessionStorage.setItem("floorId","")
                sessionStorage.setItem("floor","")
            }
        }
        this.setState(prevState => ({
            ...this.state,
            resultBuilding:sessionStorage.getItem("building")!=null?sessionStorage.getItem("building"):this.props.buildingList && this.props.buildingList.length>0? this.props.buildingList[0]['building_id']:'',
            buildingId: sessionStorage.getItem("buildingId")!=null?sessionStorage.getItem("buildingId"):this.props.buildingList && this.props.buildingList.length>0? this.props.buildingList[0]['id']:'',
            buildingName:sessionStorage.getItem("buildingName")!=null?sessionStorage.getItem("buildingName"):this.props.buildingList && this.props.buildingList.length>0? this.props.buildingList[0]['building_name']:'',
            resultFloor: "",
            floorId: flag ? prevState.floorId : "",
            floorName: flag ? prevState.floorName : "",
            areas: flag ? prevState.areas : [],
            floor_plan: flag ? prevState.floor_plan : "",
            show: false,
        }), async () => {
            await this.props.fetchFloors(this.state.buildingId).then(() => {
                this.onSelectFloor("","onMount")
            })
        })
    }

    onSelectFloor = (event, flag = false) => {
        if (flag === false) {
            const { value, selectedOptions } = event.target
            sessionStorage.setItem("floorName", selectedOptions[0].innerText)
            sessionStorage.setItem("floorId", selectedOptions[0].id)
            sessionStorage.setItem("floor", value)
        }
        else if(flag=="onMount"
        && this.props.buildingList 
        && this.props.buildingList.length>0
        && this.props.buildingList[0]['floors']
        && this.props.buildingList[0]['floors'].length>0){
            sessionStorage.setItem("floorName",this.props.buildingList[0]['floors'][0]['floor_name'])
            sessionStorage.setItem("floorId",this.props.buildingList[0]['floors'][0]['id'])
            sessionStorage.setItem("floor",this.props.buildingList[0]['floors'][0]['id'])
        }
        this.setState(prevState => ({
            ...this.state,
            resultFloor: sessionStorage.getItem("floor")?sessionStorage.getItem("floor"):this.props.buildingList ? this.props.buildingList.length>0? this.props.buildingList[0]['floors'].length>0?  this.props.buildingList[0]['floors'][0]['id']:'':'':'',
            floorId:sessionStorage.getItem("floorId")?sessionStorage.getItem("floorId"):this.props.buildingList ? this.props.buildingList.length>0? this.props.buildingList[0]['floors'].length>0?  this.props.buildingList[0]['floors'][0]['id']:'':'':'',
            floorName:sessionStorage.getItem("floorName")?sessionStorage.getItem("floorName"):this.props.buildingList ? this.props.buildingList.length>0? this.props.buildingList[0]['floors'].length>0?  this.props.buildingList[0]['floors'][0]['floor_name']:'':'':'',
            show: false,
            floor_plan: flag ? prevState.floor_plan : "",
        }))
    }

    ErrorDetails = () => {
        appInsights.trackTrace({ message: errorDetails, properties: { page: "resultDisplay" }, severityLevel: SeverityLevel.Verbose })
        if(window.location.pathname === '/results/biomeresults/' || window.location.pathname === '/results/biomeresults'){
            toast.error(errorDetails, {
                position: toast.POSITION.BOTTOM_RIGHT
            })
        }
        errorDetails = ""
        return true
    }

    isvalidData = (data) => {
        let isValidFromDate = moment(data.datetime).isValid()
        let isValidToDate = moment(data.todatetime).isValid()
        if (data.buildingId && data.floorId && isValidFromDate && isValidToDate && (data.datetime.setHours(0, 0, 0, 0) <= data.todatetime.setHours(0, 0, 0, 0))) {
            return true
        }
        else if (!data.buildingId) {
            errorDetails = "Please select a Building!"
            return false
        }
        else if (!data.floorId) {
            errorDetails = "Please select a Floor!"
            return false
        }
        else if (!isValidFromDate) {
            errorDetails = "Please select proper From Date!"
            return false
        }
        else if (!isValidToDate) {
            errorDetails = "Please select proper To Date!"
            return false
        }
        else {
            errorDetails = "Please select the right timeframe!"
            return false
        }
    }

    applyFilter = () => {
        if (this.isvalidData(this.state)) {
            var data = {
                organism: '',
                date_time: moment.utc(new Date(this.state.datetime)).format("YYYY-MM-DD"),
                to_date: moment.utc(new Date(this.state.todatetime)).format("YYYY-MM-DD"),
                floor__id: this.state.floorId,
                type_of_samples: '',
                analysis: 'Microbiome',
            }

            this.setState({
                show: true,
                clickedFloorArea: undefined,
                floorSampleResults: undefined
            })
            this.fetchLocationAreas(data)
            this.updateWindowDimensions()
        }
        else {
            this.ErrorDetails()
            this.setState({
                resultsData: []
            })
        }
    }

    getDatetime = date => {
        let datetime = new Date()

        datetime.setDate(date.getDate());
        datetime.setMonth(date.getMonth());
        datetime.setFullYear(date.getFullYear());
        return datetime
    }

    onChange = date => {
        return this.setState({ date_time: this.getDatetime(date) })
    };

    onDateChange = date => {
        if(date===undefined){
            this.setState({ datetime: this.getDatetime(moment.utc(new Date(this.getEarliestDate()))['_d']) })
        }
        else{
            this.setState({ datetime: this.getDatetime(date) })
        }
        
    }
    onToDateChange = date => {
        if(date === undefined){
            this.setState({ todatetime: this.getDatetime(moment.utc(new Date())['_d'])})  
            
        }
        else{
            this.setState({ todatetime: this.getDatetime(date) })
        }
        
    }

    resetData = () => {
        this.setState({
            ...this.floorInitialState,
            resultBuilding: "",
            buildingId: "",
            buildingName: "",
            resultFloor: "",
            floorId: "",
            floorName: "",
        })
        window.sessionStorage.removeItem('applyFilterAutoSelect')
        window.sessionStorage.removeItem('buildingNameAutoSelect')
        window.sessionStorage.removeItem('floorNameAutoSelect')
        window.sessionStorage.removeItem('buildingName')
        window.sessionStorage.removeItem('building')
        window.sessionStorage.removeItem('buildingId')
        window.sessionStorage.removeItem('floorName')
        window.sessionStorage.removeItem('floor')
        window.sessionStorage.removeItem('floorId')
    }

    clicked = (area) => {
        if(area == undefined){
            this.state.areas.forEach((item, index) => {
                if(item.name == this.state.roomName){
                    area = item
                }
            })
        }
        let val
        for(let i = 0; i < this.state.allSamples.length; i++) {
            if(area.locationObject.location_id === this.state.allSamples[i].location_id){
                val = this.state.allSamples[i]
            }
        }
        this.setState({
            roomName: area.name,
            clickedFloorArea: area,
            floorSampleResults: undefined,
            selectedFloorValues: val,
        })
    }

    getSampleMapping = (samples_list, coords, locationObject, areas) => {
        if (coords.length > 4) {
            coords = locationObject.rect_coordinates.split(",").map(Number)
        }
        let [x1, x2] = coords[0] < coords[2] ? [coords[0], coords[2]] : [coords[2], coords[0]]
        let [y1, y2] = coords[1] < coords[3] ? [coords[1], coords[3]] : [coords[3], coords[1]]
        let [width, height] = [x2 - x1, y2 - y1]

        let len = 10 //length of the square
        let mar = 8 //margin between the squares

        let [samples_width, no_samples_height] = [~~(width / (len + mar)) - 1, ~~(height / (len + mar)) - 1]

        samples_list.map((sampleObject, i) => {
            let preFillColor, strokeColor
            let horiz_count = ~~(i % samples_width) // nth sample position horizontally in location
            let vert_count = ~~(i / samples_width) //  nth sample position vertically in location
            let coords = [x1 + mar * (horiz_count + 1) + len * horiz_count, y1 + mar * (vert_count + 1) + len * vert_count, x1 + mar * (horiz_count + 1) + len * (horiz_count + 1), y1 + mar * (vert_count + 1) + len * (vert_count + 1)]
            preFillColor = (sampleObject.result.other_analysis == "Positive") ? "#f9766e" : (sampleObject.result.other_analysis == "Negative") ? "#00bfc4" : "#3e58c7"
            strokeColor = (sampleObject.result.other_analysis == "Positive") ? "#f9766e" : (sampleObject.result.other_analysis == "Negative") ? "#00bfc4" : "#3e58c7"
            areas.push({ name: sampleObject.sample_id, shape: "rect", coords: coords, preFillColor: preFillColor, strokeColor: strokeColor, type: 'sample', rx: '6px' })
        })
        return areas
    }

    getLocationMapping = (locationData) => {
        let areas = []
        let [floor_map, floor_name, floor_plan_width, building_name] = ''
        let floor_data = locationData.floor_data

        floor_map = floor_data.floor_plan
        floor_name = floor_data.floor_name
        floor_plan_width = floor_data.floor_plan_width
        building_name = floor_data.building.building_name

        let locationMapData = locationData.data

        locationMapData.map((locationObject, i) => {
            let coords = locationObject.coordinates.split(",").map(Number)
            let samples_list = locationObject.samples
            let room_id = locationObject.room.room_id
            let sample_areas = []
            let shape = ""
            if (coords.length > 4) {
                shape = "poly"
            }
            else {
                shape = "room"
            }
            if (samples_list.length > 0) {
                sample_areas = this.getSampleMapping(samples_list, coords, locationObject, sample_areas)
            }
            //room_name
            areas.push({ name: locationObject.room.room_name, sample_areas: sample_areas, shape: shape, coords: coords, locationObject: locationObject, samples: locationObject.samples, type: 'result_display_room', strokeColor: '#9398c7', preFillColor: "#f1f2f869", fillColor: "#ebfcfc", clickedFillColor: "#dfe2f780", clickedStrokeColor: '#143d8d', text: locationObject.room.room_name });
            areas.push(...sample_areas)
        });
        return [areas, floor_map, floor_name, floor_plan_width, building_name]
    }

    fetchLocationAreas = (data) => {
        this.setState({ loader: true })
        this.props.fetchLocationResultsData(data).then(response => {
            if (response.status === 200) {
                if ("locations_data" in response.data && "stats" in response.data) {
                    appInsights.trackTrace({ message: 'Flooplan and Location Data is fetched successfully', properties: { page: "resultDisplay", name: response.data.locations_data.floor_data.floor_name, id: this.state.floorId }, severityLevel: SeverityLevel.Information });
                    let locations_data = response.data.locations_data
                    let stats = response.data.stats
                    let all_samples = response.data.all_samples
                    let sampleData = this.props.locationAreas.locations_data.data
                    let resultData = sampleData.filter((object) => {
                        if (object.samples.length > 0) {
                            return object
                        }
                    })

                    let [areas, floor_plan, floor_name, floor_plan_width, building_name] = this.getLocationMapping(locations_data)
                    this.setState({
                        clickedFloorArea: undefined,
                        roomName: areas.length == 0 ? "" : areas[0].name,
                        areas: [...areas],
                        floor_plan: floor_plan,
                        floor_name: floor_name,
                        floor_plan_width: floor_plan_width,
                        building_name: building_name,
                        totalSamples: stats.total_samples,
                        totalResults: stats.results,
                        allSamples: all_samples,
                        selectedFloorValues: '',
                        loader: false,
                        floorSampleResults: resultData
                    })
                }
            }
            else {
                this.setState({ loader: false })
                let message = "Errors in loading locations data!"
                appInsights.trackTrace({ message: message, properties: { page: "resultDisplay", name: this.state.floorName, id: this.state.floorId }, severityLevel: SeverityLevel.Error });
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch((error) => {
            let message = "Errors in loading locations data!"
            appInsights.trackTrace({ message: message, properties: { page: "resultDisplay", name: this.state.floorName, id: this.state.floorId, error: error }, severityLevel: SeverityLevel.Error });
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }

    zoomIn = () => {
        let width = this.state.width
        if (width < 2000) {
            width = width + ((2 / 100) * width)
            this.setState({ width: width, zoomOutEnabled: true, zoomInEnabled: width < 2000 ? true : false })
            
            //To increase each coordinate value to keep the mapping in place
            if(!localStorage.getItem('guest') && !localStorage.getItem('species')){
                this.state.areas.forEach((item, index) =>{
                    let new_coords = []
                    let new_item 
                    item['coords'].forEach((item) => {
                        new_item = item + ((2 / 100) * item)
                        new_coords.push(new_item)
                    })
                    this.state.areas[index]['coords'] = new_coords
                    let new_areas = this.state.areas
                    new_areas.coords = new_coords
                })
                this.setState({areas : this.state.areas})
                if(this.state.clickedFloorArea){
                    this.clicked()
                }
            }
        }
    }

    zoomOut = () => {
        let actualwidth = window.innerWidth > 1114 ? window.innerWidth * 0.75 : window.innerWidth * 0.66
        let width = this.state.width
        if (width > actualwidth) {
            width = width - ((2 / 100) * width)
            this.setState({ width: width, zoomInEnabled: true, zoomOutEnabled: width > actualwidth })
        
            //To decrease each coordinate value to keep the mapping in place
            if(!localStorage.getItem('guest') && !localStorage.getItem('species')){
                this.state.areas.forEach((item, index) =>{
                    let new_coords = []
                    let new_item 
                    item['coords'].forEach((item) => {
                        new_item = item - ((2 / 100) * item)
                        new_coords.push(new_item)
                    })
                    this.state.areas[index]['coords'] = new_coords
                    let new_areas = this.state.areas
                    new_areas.coords = new_coords
                })
                this.setState({areas : this.state.areas})
                if(this.state.clickedFloorArea){
                    this.clicked()
                }
            }
        }
    }

    toggleUploadModal = () => {
        this.setState(prevState => ({
            isUploadModalOpen: !prevState.isUploadModalOpen,
        }));
    }

    getFileName = () => {
        let Filename = "Results_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        this.setState({ fileName: Filename })
    }

    clearUpload = () => {
        this.setState({ resultFile: undefined });
    }

    uploadMicroResults = () => {
        if (!this.state.resultFile) {
            let message = "Microbiome Results Upload failed. Please choose a file!"
            appInsights.trackTrace({ message: message, properties: { page: "microbiomeResults", type: "Microbiome" }, severityLevel: SeverityLevel.Verbose })
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else {
            this.setState({ loader: true })
            this.props.uploadResults(this.state.resultFile, false, true).then((res) => {
                if (res && res.data) {
                    this.setState({ loader: false, isUploadModalOpen: false, resultFile: "" })
                    this.props.downloadResultData()
                    let total = res.data.number_of_results_uploaded + res.data.number_of_invalids + res.data.number_of_duplicates
                    let uploaded = res.data.number_of_results_uploaded
                    let message = (uploaded) + " out of " + (total) + " results uploaded successfully."
                    appInsights.trackEvent({ name: 'SNP Results Uploaded', properties: { uploaded: uploaded, invalid: res.data.number_of_invalids, duplicates: res.data.number_of_duplicates } });
                    appInsights.trackTrace({ message: 'SNP Results Uploaded', properties: { uploaded: uploaded, invalid: res.data.number_of_invalids, duplicates: res.data.number_of_duplicates }, severityLevel: SeverityLevel.Information })
                    toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
                    if (res.status === 203) {
                        message = "Found " + (res.data.number_of_invalids) + " results with invalid data."
                        toast.warn(message, { position: toast.POSITION.BOTTOM_RIGHT })
                    }
                    else if (res.status === 202) {
                        message = "Found " + (res.data.number_of_duplicates) + " duplicate barcodes."
                        toast.warn(message, { position: toast.POSITION.BOTTOM_RIGHT })
                    }
                }
            }).catch((e) => {
                this.setState({ loader: false })
                if (e.status === 400) {
                    let message = ''
                    if (e.data['invalid_headers'] || e.data['result_headers'] || e.data['barcode'])
                        message = "Upload failed due to invalid headers, please refer the template for more updates!!"
                    else if (e.data['empty_data'])
                        message = "Upload failed due to empty data in the file!!"
                    else if (e.data['snp_error'])
                        message = e.data['snp_error']
                    else if (e.data['number_of_invalids'])
                        message = "Upload failed due to invalid data!!"
                    else
                        message = "Upload failed, try again after rechecking the data!!"
                    appInsights.trackTrace({ message: message, properties: { file: this.state.resultFile, page: "snpDistance", type: 'SNP', error: e }, severityLevel: SeverityLevel.Error })
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    })
                }
                else {
                    let message = "Upload failed due to an unexcpected error!!."
                    appInsights.trackTrace({ message: message, properties: { file: this.state.resultFile, page: "snpDistance", type: 'SNP', error: e }, severityLevel: SeverityLevel.Error })
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    })
                }
            })
        }
    }

    onChangeFile = event => {
        let allowedExtensions = ["xlsx"];
        let file = event.target.files;
        if (file.length > 0 && !allowedExtensions.includes(file[0].name.split('.').slice(-1)[0])) {
            appInsights.trackTrace({ message: "Incorect file format, Please choose an Excel file (.xlsx)", properties: { page: "snpDistance", type: 'SNP' }, severityLevel: SeverityLevel.Verbose })
            toast.warn("Incorect file format, Please choose an Excel file (.xlsx)", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else {
            file[0]['displayName'] = file[0].name.split(".")[0];
            if (file[0]['displayName'].length > 15) file[0]['displayName'] = file[0]['displayName'].substring(0, 15) + '...';
            this.setState({ resultFile: file[0] });
        }
    }

    render() {
        return (
            <div className='page-layout'>
                <NavBar />
                <div className='dashboard-overview results-page' data-tut="reactour__results" ref={(divElement) => { this.divElement = divElement }} >
                    <div className="dashboard-content-25">
                        <Row className="sample-list-header" form>
                            <Navbar className="navbar-results " light expand="md">
                                <Nav navbar data-tut="reactour__nav">
                                    <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/viewresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />All Results</span></NavLink>
                                    <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/trackresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />Track Result</span></NavLink>
                                    <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/snpresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />SNP Result</span></NavLink>
                                    <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding remove-style" activeClassName="active" to="/results/biomeresults/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt='' />Microbiome Result</span></NavLink>
                                    <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/speciesdensity/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=""/>Species Density</span></NavLink>
                                </Nav>
                            </Navbar>
                        </Row>
                        <div className='sample-input-area' data-tut="reactour__apply">
                            <Row form>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultBuilding ? this.props.sideBarHover? "sample-input-fields no-display":"sample-input-fields" : this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultBuilding" value={this.state.resultBuilding} onChange={this.onSelectBuilding} size="1">
                                        <option value="" default disabled>Building*</option>
                                        {this.props.buildingList.map((building, key) => {
                                            return <option className="dashboard-options" id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                        })}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultFloor ? this.props.sideBarHover?"sample-input-fields no-display":"sample-input-fields" : this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultFloor" value={this.state.resultFloor} onChange={this.onSelectFloor}>
                                        <option value="" default disabled>Floor*</option>
                                        {this.props.floorsList.map((floor, key) => {
                                            return <option className="dashboard-options" id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                        })}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <div>
                                        <DatePicker
                                            popperProps={{
                                                positionFixed: true
                                            }}
                                            className="sample-input-fields form-control"
                                            wrapperClassName="datepicker-wrapper"
                                            selected={this.state.datetime}
                                            onChange={this.onDateChange}
                                            filterDate={(date) => {
                                                return moment() > date;
                                            }}
                                            maxDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="MMMM d, yyyy"
                                            dateFormatCalendar=" "
                                            placeholderText="Date*"
                                            popperModifiers={{
                                                preventOverflow: {
                                                    enabled: true,
                                                },
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <div>
                                        <DatePicker id="floor-date-time" onChange={this.onToDateChange} selected={this.state.todatetime}
                                            popperProps={{
                                                positionFixed: true
                                            }}
                                            className="sample-input-fields form-control"
                                            wrapperClassName="datepicker-wrapper"
                                            maxDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="MMMM d, yyyy"
                                            dateFormatCalendar=" "
                                            placeholderText="To*"
                                            autoComplete='off'
                                            portalId='root'
                                            popperModifiers={{
                                                preventOverflow: {
                                                    enabled: true,
                                                },
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col className="clear-apply-end" data-tut="reactour__apply">
                                    <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                    <Button id="applyFloorButton" type="submit" onClick={this.applyFilter}>Apply{this.state.loader ? <Spinner className="sample-floor-spinner" /> : null}</Button>
                                </Col>
                            </Row>
                        </div>
                    </div>


                    <div className="grid-data width" data-tut="reactour__resultView">
                        {this.state.show ?
                            <>
                                <Row className="sample-list-header samples-page" data-tut="reactour__floor" form>
                                    <Col className="nav-links">
                                        <Navbar className="navbar-results" light expand="md">
                                            <Nav navbar data-tut="reactour__grid">
                                                <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/biomeresults/"><span className="nav-col"><img src={eyeIcon} className="nav-icons" alt='' />Floor View</span></NavLink>
                                                <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/biomeresults/grid-view" ><span className="nav-col"><img src={listIcon} className="nav-icons" alt='' />List View</span></NavLink>
                                            </Nav>
                                        </Navbar>
                                    </Col>
                                    <div className='floorview-header-text'>
                                        <Col className="results-count-text sample-taken">Sample Taken <span className="samples-count-value">{this.state.totalSamples}</span>
                                        </Col>
                                        <Col className="results-count-text">Results Available <span className="samples-count-value">{this.state.totalResults}</span>
                                        </Col>
                                    </div>
                                    <hr className="break-line" />
                                </Row>

                                {this.state.clickedFloorArea ?
                                    <ResultDisplaySamples roomDetails={this.state.clickedFloorArea} roomName={this.state.roomName} values={this.state.selectedFloorValues}></ResultDisplaySamples>
                                    :
                                    null
                                }
                                {this.state.floorSampleResults ?
                                    <FloorResultDisplay roomDetails={this.state.floorSampleResults} datetime={this.state.datetime} ></FloorResultDisplay>
                                    :
                                    null
                                }
                                <Row className="d-flex justify-content-end">
                                    <Col sm={1} md={1} lg={1} className="zoom-borders">
                                        <div className={"border-icons border-icons-left" + (this.state.zoomInEnabled ? "" : " border-icons-disable")} id="ZoomIn" onClick={this.zoomIn} >
                                            <img id="ZoomIn" src={zoomInIcon} alt='' />
                                            <UncontrolledTooltip placement="top" target="ZoomIn">
                                                Zoom In
                                            </UncontrolledTooltip>
                                        </div>
                                        <div className={"border-icons border-icons-right" + (this.state.zoomOutEnabled ? "" : " border-icons-disable")} id="ZoomOut" onClick={this.zoomOut}>
                                            <img src={zoomOutIcon} alt='' />
                                            <UncontrolledTooltip placement="top" target="ZoomOut">
                                                Zoom Out
                                            </UncontrolledTooltip>
                                        </div>
                                    </Col>
                                </Row>
                                {this.state.areas && this.state.floor_plan ?
                                    <>
                                    <Row>
                                        {this.state.areas.some(area=>area.text === "Unknown Room")?
                                            <Col sm={4} md={3} lg={3} xl={2}>
                                                <div>
                                                    <img className="right-align-unknown-room" src={unknownLocation} alt='' title="Unknown room"/>
                                                </div>
                                            </Col>
                                        :null}
                                    </Row>
                                    <Row>
                                        <Col className="center-align floorplan-overflow">
                                            <ImageMapper
                                                ref={this.floorElement}
                                                id='map'
                                                src={this.state.floor_plan}
                                                key={this.state.areas.length}
                                                map={{ name: this.state.name, areas: this.state.areas }}
                                                imgWidth={this.state.floor_plan_width}
                                                width={this.state.width}
                                                currentlyClickedArea={this.state.clickedFloorArea}
                                                onClick={area => this.clicked(area)}
                                            />
                                        </Col>
                                    </Row>
                                    </>
                                    : null}
                            </>
                            :
                            <>
                                <Row className="sample-list-header" form>
                                    <Navbar className="navbar-results" light expand="md">
                                        <Nav navbar data-tut="reactour__grid">
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/biomeresults/"><span className="nav-col"><img src={eyeIcon} className="nav-icons" alt='' />Floor View</span></NavLink>
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/biomeresults/grid-view" ><span className="nav-col"><img src={listIcon} className="nav-icons" alt='' />List View</span></NavLink>
                                        </Nav>
                                    </Navbar>
                                </Row>
                                <div className="no-data-msg results-data">Select above criteria and click on Apply button to view data. </div>
                            </>
                        }
                    </div>
                </div>
                <ToastContainer autoClose={3000} />
                {this.props.isTourOpen ? <Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} /> : null}
                <Modal isOpen={this.state.isUploadModalOpen} toggle={this.toggleUploadModal} size="lg">
                    <ModalHeader toggle={this.toggleUploadModal} className="edit-popup">Upload Results</ModalHeader>
                    <ModalBody className="upload-body">
                        <Row xs="2">
                            <Col>
                                <FontAwesomeIcon className="overlay-upload-icon upload-sample-icon-position" icon={faUpload} size="lg" />
                                <Input
                                    className="edit-input-values edit-input-values-file upload-sample-file"
                                    type="file"
                                    accept=".xlsx, .csv"
                                    placeholder="please enter file"
                                    onClick={(event) => {
                                        event.target.value = null
                                    }}
                                    onChange={this.onChangeFile}
                                    data-title={'Choose File'}
                                />
                            </Col>
                            <Col className="upload-sample-last">
                                {this.state.resultFile ?
                                    <Col className="upload-filename">
                                        <Label className="title">{this.state.resultFile.displayName}</Label>
                                        <img src={deleteIconRed} className="overlay-upload-icon trash-icon" alt=''
                                            onClick={this.clearUpload}
                                        />
                                    </Col> : <></>}
                            </Col>
                            <Col>
                                <div className="vertical-line"></div>
                                <div style={{display: "none"}} element={<Button id="export-data-button" className="export-data-button  sample-template-button" onClick={this.getFileName}>Download Result Template</Button>} filename={this.state.fileName}>
                                    <div data={dataset} name="Results">
                                        <div label="*BarCode" value="barcode" />
                                        <div label="BatchNumber" value="bn" />
                                        <div label="TypeOfSample" value="typeOfSample" />
                                        <div label="TypeOfAnalysis" value="typeOfAnalysis" />
                                        <div label="*LocationId" value="locationId" />
                                        <div label="*DateTime" value="dateTime" />
                                        <div label="Comments" value="comments" />
                                        <div label="Results" value="results" />
                                    </div>
                                </div>
                                <div className="edit-popup">
                                    <h5 className="modal-text lowertag lowertag-align">* are mandatory to fill</h5>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="float-sm-right bottom-options">
                        <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={this.clearUpload}>Clear</Button>
                        <Button
                            className="button-size custom-button save-upload-delete-button"
                            id="export-data-button"
                            labelColor="#000"
                            backgroundColor="#FFF"
                            fullWidth={true}
                            onClick={() => this.uploadMicroResults()}
                        >
                            Save
                        </Button>
                        {this.state.loader ? <Spinner size="sm" color="primary" /> : null}
                    </ModalFooter>
                </Modal>
            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
        locationAreas: state.location_data.locationData,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
        filters: state.results_data.filters,
        sampleData: state.sample_data.downloadSampleData,
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchLocationResultsData,
        fetchBuilding,
        fetchFloors,
        fetchFloorPlan,
        saveSample,
        updateSample,
        deleteSample,
        uploadResults,
        downloadResultData,
        fetchFilterOptions,
        downloadSampleData
    }
)(microbiomeResults), 'microbiomeResults', 'microbiomeResults')